var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3125_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06575 26.0832C5.03109 21.7251 5.05535 19.9501 5.15189 19.7653C5.30549 19.4712 6.63562 18.0469 9.13909 15.4971C10.3647 14.2488 11.9663 12.5837 12.698 11.7971C13.4298 11.0104 14.5868 9.79653 15.2695 9.1C15.9522 8.40346 16.8986 7.42266 17.3724 6.9208L18.234 6.008L22.5844 6.0208L26.9346 6.03333L26.9351 16.1333L26.9359 26.2333L22.6015 26.2504L18.2674 26.2677V22.6005C18.2674 20.2893 18.2436 18.9333 18.2031 18.9333C18.1676 18.9333 18.1047 18.9968 18.0634 19.0741C18.022 19.1515 17.1311 20.0888 16.0842 21.1573C14.4906 22.7835 13.0844 24.2744 11.7282 25.7755C11.2508 26.3037 11.5226 26.2667 8.11909 26.2667C5.06735 26.2667 5.06709 26.2667 5.06575 26.0832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0497 9.68848C5.03983 7.71488 5.0409 6.07755 5.05236 6.05008C5.07423 5.99701 16.0652 5.97808 16.0652 6.03115C16.0652 6.04821 15.7972 6.32048 15.4697 6.63621C15.1422 6.95195 14.2798 7.84555 13.5534 8.62181C12.827 9.39808 12.0484 10.2191 11.8225 10.4466C11.5966 10.6741 11.4012 10.8874 11.3884 10.9205C11.3756 10.9535 10.878 11.4874 10.2822 12.1069L9.1993 13.2333L7.13343 13.2551L5.06756 13.2767L5.0497 9.68848Z",
    fill: "#EFEFF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3125_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1333,
    height: 20.5333,
    fill: "white",
    transform: "translate(5.06641 5.86664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnime);
export default __webpack_public_path__ + "static/media/ANIME.74b2b3226451265f54df989b9e2e67fe.svg";
export { ForwardRef as ReactComponent };